import Axios from 'axios';

import { SET_CREATE_IS_VISIBLE, CREATE_PROJECT_ERROR } from './constants';

export const setCreateIsVisible = isVisible => ({
    type: SET_CREATE_IS_VISIBLE,
    isVisible,
});
export const setCreateProjErr = createProjectErr => ({
    type: CREATE_PROJECT_ERROR,
    createProjectErr,
});

export const createProject = (authToken, project) => (dispatch) => {
    const optionAxios = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
        },
    };
    const payload = {
        project: {
            name: project.inputs.projectAddress.projectName,
            include_cash: project.inputs.includeCash,
            is_locked: project.inputs.settings.isLocked,
            is_archived: project.inputs.projectStatus.archiveStatus,
            job_status: project.inputs.projectStatus.jobStatus,
            is_sold: project.inputs.projectStatus.soldStatus,
            customer_id: project.inputs.clientId,
            address_attributes: {
                address_1: project.inputs.projectAddress.projectStreet,
                address_2: project.inputs.projectAddress.projectStreet2,
                city: project.inputs.projectAddress.projectCity,
                state: project.inputs.projectAddress.projectState,
                country: project.inputs.projectAddress.projectCountry,
                zip_code: project.inputs.projectAddress.projectZip,
            },
            cap_attributes: {
                term_in_months: project.inputs.cap.capTerm,
                down_payment: project.inputs.cap.capDownPayment,
                show_cap: project.inputs.cap.showCAP,
            },
            ess_attributes: {
                stroage_kw: project.inputs.ess.esskW,
                storage_kwh: project.inputs.ess.esskWh,
                include_in_simulation: project.inputs.ess.includeESS,
                price: project.inputs.ess.essPrice,
                made_in_ca: project.inputs.ess.madeInCA,
                battery_type: project.inputs.ess.batteryType,
            },
            loan_attributes: {
                loan_type: project.inputs.loan.loanProvider,
                down_payment: project.inputs.loan.downPayment,
                rate: project.inputs.loan.loanInterest,
                term_in_months: project.inputs.loan.loanTerm,
                show_loan: project.inputs.loan.showLoan,
                mosaic_term: project.inputs.loan.mosaicTerm,
                mosaic_down_payment: project.inputs.loan.mosaicDownPayment,
            },
            nyserda_attributes: {
                ny_rebate: project.inputs.nyserda.nyRebate,
            },
            ppa_attributes: {
                rate: project.inputs.ppa.ppaRate,
                escalator: project.inputs.ppa.ppaEscalator,
                term_in_years: project.inputs.ppa.ppaTerm,
                include_ppa: project.inputs.ppa.showPPA,
            },
            obs_attributes: {
                length: project.inputs.obs.obsTerm,
                obs_credit: project.inputs.obs.obsCredit,
                down_payment: project.inputs.obs.obsDownPayment,
                show_obs: project.inputs.obs.showOBS,
            },
            sgip: {
                sgip_toggle: project.inputs.sgip.sgipToggle,
                sgip_value: project.inputs.sgip.sgipValue,
            },
            smart_attributes: {
                incentive_rate_in_kwh: project.inputs.smart.smartValue,
            },
            solar_attributes: {
                annual_degredation: project.inputs.solar.annualDeg,
                energy_value: project.inputs.solar.solarValue,
                kwh_per_kw: project.inputs.solar.productionRatio,
                system_price: project.inputs.solar.cashprice,
                system_size_kw: project.inputs.solar.systemSize,
                install_type: project.inputs.solar.installType,
                install_type_2: project.inputs.solar.installType2,
                system_notes: project.inputs.solar.systemNotes,
                solar_panel: project.inputs.solar.solarPanel,
                inverter: project.inputs.solar.inverter,
            },
            tax_obligation_attributes: {
                installation_year: project.inputs.tax.installYear,
                rate: project.inputs.tax.taxRate,
                residential: project.inputs.tax.resiToggle,
                tax_paying_entity: project.inputs.tax.taxEntity,
            },
            utility_attributes: {
                annual_consumption: project.inputs.utility.annualKWH,
                annual_fixed_charge: project.inputs.utility.aFixedCharge,
                annual_inflation_percentage: project.inputs.utility.annualInflation,
                rate_per_kwh: project.inputs.utility.energyValue,
                utility_type: project.inputs.utility.provider,
                total_kwhs: null,
            },
        },
    };
    Axios.post('v1/project', payload, optionAxios)
        .then((res) => {
            dispatch(setCreateProjErr(`Successfully created: ${res.data.project.name}`));
        }).catch((err) => {
            dispatch(setCreateProjErr('There was an error creating this project.'));
            console.log(err);
        });
};



// WEBPACK FOOTER //
// ./src/containers/NewProject/actions.js